import { render } from "./create_rate.vue?vue&type=template&id=1cb7c12e&scoped=true"
import script from "./create_rate.vue?vue&type=script&lang=js"
export * from "./create_rate.vue?vue&type=script&lang=js"

import "./create_rate.vue?vue&type=style&index=0&id=1cb7c12e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb7c12e"]])

export default __exports__